import React from 'react';

import { DefaultWidgetWithHeader } from '../../_lib/components/Widget';
import { Widget as WidgetShape } from '../../types/api/Widget';
import { UserAnonymousBlock } from '../../_blocks/UserAnonymous';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { useSonTranslation } from '../../translation/useSonTranslation';

export type UserAnonymousWidget = WidgetShape<[UserAnonymousBlock], WidgetType.useranonymous>;

export function UserAnonymousWidget({ blocks, elementType, ...headerProps }: UserAnonymousWidget) {
  const { t } = useSonTranslation('UserAnonymous');

  return (
    <DefaultWidgetWithHeader
      {...headerProps}
      widgetType={elementType}
      icon={Icons.CLOSED_LOCK}
      hierarchy={3}
      title={t('loginText')}
    >
      <UserAnonymousBlock {...blocks[0]} />
    </DefaultWidgetWithHeader>
  );
}
